import angular from 'angular';
import { throttle } from 'lodash';

// The sticky container/element structure lets you define an element that will
// follow you as you scroll down the page, but which will stop at top/bottom
// breakpoints.
//
// To use it, define two divs: od-sticky-container, and od-sticky-element
// inside it.  od-sticky-element will assume the width of od-sticky-container,
// and will start at the top of the container. As you scroll it will follow
// you, until it hits the bottom of od-sticky-container and stops there (until
// you scroll back up).
module.exports = angular.module('market.components.od-sticky-element', [])
.directive('odStickyContainer', function() {
  function OdStickyContainer($element, $window) {
    this.$element = $element;
    this.$window = $window;
  }

  OdStickyContainer.prototype.getTop = function() {
    return this.$element.prop('offsetTop') + Number(this.$element.css('paddingTop'));
  };

  OdStickyContainer.prototype.getBottom = function() {
    return this.getTop() + this.$element.prop('offsetHeight');
  };

  OdStickyContainer.prototype.getWidth = function() {
    var style = this.$window.getComputedStyle(this.$element[0]);
    return parseInt(style.width) - parseInt(style.paddingLeft) - parseInt(style.paddingRight);
  };

  return {
    restrict: 'EA',
    controller: OdStickyContainer
  };
})

.directive('odStickyElement', function($window) {
  return {
    restrict: 'EA',
    require: '^odStickyContainer',
    link: function(scope, elem, attrs, odStickyContainer) {
      // Safari will return auto unless the element is positioned
      elem.css('position', 'relative');
      var marginTop = parseInt($window.getComputedStyle(elem[0]).top) || 0;
      elem.css('position', null);
      var windowEl = angular.element($window);

      var throttledOnScroll = throttle(onScroll, 10);
      var throttledOnWindowResize = throttle(onWindowResize, 100);

      windowEl.on('scroll', throttledOnScroll);
      windowEl.on('resize', throttledOnWindowResize);

      scope.$on('$destroy', function() {
        windowEl.off('scroll', throttledOnScroll);
        windowEl.off('resize', throttledOnWindowResize);
      });

      // Initialize the sticky element with the correct width
      setElementWidthToContainerWidth();

      function onWindowResize() {
        setElementWidthToContainerWidth();
        recalculateStickyPlacement();
      }

      function onScroll() {
        recalculateStickyPlacement();
      }

      // Set the width of the stickyElement to the width of the container.
      // We need to do this because we use "position: fixed" in sticky mode.
      function setElementWidthToContainerWidth() {
        elem.css('width', odStickyContainer.getWidth() + 'px');
      }

      // Check scroll position to see whether the sticky element should be
      // at the top of its container, following the user's scroll, or at
      // the bottom of the container. Set classes accordingly.
      function recalculateStickyPlacement() {
        var scrollY = $window.scrollY + marginTop;
        if (scrollY < odStickyContainer.getTop()) {
          elem.addClass('top');
          elem.removeClass('sticky');
          elem.removeClass('bottom');
        } else if (scrollY + elem.prop('offsetHeight') > odStickyContainer.getBottom()) {
          elem.removeClass('top');
          elem.removeClass('sticky');
          elem.addClass('bottom');
        } else {
          elem.removeClass('top');
          elem.addClass('sticky');
          elem.removeClass('bottom');
        }
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-sticky-element.js
 **/